export const TEMPLATE_NAME_MIN_LENGTH = 3;

export const TEMPLATE_NAME_INPUT_ERROR_MIN =
  'Nome do modelo precisa ter no mínimo 3 caracteres.';

export const TEMPLATE_NAME_INPUT_ERROR_SPECIAL =
  'Nome do modelo não pode conter caracteres especiais.';

/** Letters, numbers and spaces only. */
const TEMPLATE_NAME_PATTERN = /^[\p{L}\p{N}\s]+$/u;

export function normalizeTemplateName(value) {
  return String(value ?? '').trim();
}

/** Returns an error message while editing, or null if valid/empty. */
export function getTemplateNameInputError(value) {
  const trimmed = normalizeTemplateName(value);
  if (!trimmed) return null;

  if (trimmed.length < TEMPLATE_NAME_MIN_LENGTH) {
    return TEMPLATE_NAME_INPUT_ERROR_MIN;
  }

  if (!TEMPLATE_NAME_PATTERN.test(trimmed)) {
    return TEMPLATE_NAME_INPUT_ERROR_SPECIAL;
  }

  return null;
}

export function isValidTemplateName(value) {
  const trimmed = normalizeTemplateName(value);
  if (!trimmed) return false;
  return getTemplateNameInputError(trimmed) == null;
}
